module.exports = __webpack_public_path__ + "img/jiaowu_mobile5.6750e3fd.jpg";